import React, { Component } from 'react';
import Logo from '../../../assets/img/logo.png';
import './nav-bar.scss';

// Components
import { NavBarIcon } from '../nav-bar-icon/nav-bar-icon';

class NavBar extends Component {
	render(){
		return (
			<nav className='nav-container'>
				<img src={Logo} className="image-logo" alt="logo"/>
				<NavBarIcon route="/aboutus" iconName='fas fa-book-open' text='About Us'/>
				<NavBarIcon route="/gallery" iconName='fas fa-images' text='Gallery'/>
				<NavBarIcon route="/" iconName='fas fa-home' text='Home'/>
			</nav>
			
		);
	}
};

export default NavBar;